export default __webpack_public_path__ + "static/media/zonaDescarga.86ed0e2d.jpg";